import { Button, H1, Tag } from "@blueprintjs/core";
import * as React from "react";

const Modal = ({ handleClose, show, strings, vehicle, vehicleUrl }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";
  const generateVehiclePicUrl = (stockNo) => {
    if (vehicleUrl) {
      let arr;
      if (vehicleUrl.includes("%lower%")) {
        arr = vehicleUrl.split("%lower%");
        stockNo = stockNo.toLowerCase();
      } else {
        arr = vehicleUrl.split("%%");
      }
      arr.splice(1, 0, stockNo);
      return arr.join("");
    }
    return "";
  };

  let dateString = "";
  if (vehicle) {
    if (vehicle.YARD_DATE[0].indexOf("T") > -1) {
      const date = new Date(vehicle.YARD_DATE[0]);
      dateString = date.toLocaleDateString("en-US");
    } else {
      dateString = vehicle.YARD_DATE[0];
    }
  }
  
  // remove background css from main page
  const globalContainer =  document.querySelector<HTMLElement>('.css-1k7bvv7')!;
  if(globalContainer){
    globalContainer.style.backgroundColor = '#e5e5e5';
  }


  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <H1 style={{ fontWeight: "bold" }}>{strings.vehicleInformation}</H1>
        {vehicle ? (
          <div>
            <p>
              {strings.year}: {vehicle.HOL_YEAR}
            </p>
            <p>
              {strings.make}: {vehicle.MAKE[0]}
            </p>
            <p>
              {strings.model}: {vehicle.MODEL[0]}
            </p>
            <p>
              {strings.rowNumber}: {vehicle.VEHICLE_ROW[0]}
            </p>
            <p>
              {strings.stockNumber}:{" "}
              <Tag minimal={true}>{vehicle.STOCKNUMBER[0]}</Tag>
            </p>
            <p>
              VIN: <Tag minimal={true}>{vehicle.VIN[0]}</Tag>
            </p>

            <p>
              {strings.added}:{" "}
              {dateString}
            </p>

            <p>Added: {dateString}</p>

            {vehicle.BATCH_NUMBER ? (
              <img
                height={200}
                width={200}
                alt={""}
                src={generateVehiclePicUrl(vehicle.BATCH_NUMBER[0])}
              />
            ) : (
              <img height={200} width={200} alt={""} src={vehicle.URG_IMAGE} />
            )}
            {vehicle.URG_IMAGE_SLIDESHOW ? (
              <div>
                <a href={vehicle.URG_IMAGE_SLIDESHOW}>{strings.moreImages}</a>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}

        <br />
        <br />
        <Button onClick={handleClose} large={true}>
          {strings.close}
        </Button>
      </section>
    </div>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/VehicleModal.tsx